module.exports = __webpack_public_path__ + "static/media/2.8924319e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/2.png
// module id = 1285
// module chunks = 0